import { render, staticRenderFns } from "./Fotoviewer.vue?vue&type=template&id=9196dee0&"
import script from "./Fotoviewer.vue?vue&type=script&lang=js&"
export * from "./Fotoviewer.vue?vue&type=script&lang=js&"
import style0 from "./Fotoviewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports